import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => ({
  root: {
    background: theme.palette.background.default
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
